import { render, staticRenderFns } from "./ProveedorTipos.vue?vue&type=template&id=f2cb2084&"
import script from "./ProveedorTipos.vue?vue&type=script&lang=js&"
export * from "./ProveedorTipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports